import React from 'react';
import { Container } from 'react-bootstrap';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { useFirebaseContext } from '../context/ContextProvider';
import { useDataContext } from '../../../../context/AppProvider';
import DisplayList from './DisplayList';
import TrendingDisplay from './TrendingDisplay';


function MainHome() {
  
    const {name}=useDataContext();
    const {username}=useFirebaseContext();
    console.log(name)
    console.log(username)
  return (

      <Container className='mt-5'>
        <Tabs
          defaultActiveKey="home"
          id="fill-tab-example"
          className="mb-3"
          fill
        >
          <Tab eventKey="home" title="Home">
           hello {name} {username}
          </Tab>
          <Tab eventKey="CreateCard" title="Create">
            Tab content for Create A Technology Card
          </Tab>
          <Tab eventKey="longer-tab" title="ViewCard">
          <DisplayList/>
          </Tab>
          <Tab eventKey="treanding" title="Treanding Display" >
           <TrendingDisplay />
          </Tab>
        </Tabs>
      </Container>
  


  );
}

export default MainHome;